export class UpdateWorkTypeError extends Error {

}
